
import { Card, Col, Divider, Form, Input, Row, Space, Select } from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import ButtonAction from 'components/Common/ButtonAction';
import { ButtonAdd } from 'components/Common/Buttons';
import useTopbarTitleHooks from 'hooks/useTopbarTitleHooks';
import CustomAntdTable from 'components/Common/CustomAntdTable';
import { dismissToast, errorToast, successToast, loadingToastId } from 'utils/Toast';
import Constant from 'utils/Constants';
import { sorterTable } from 'utils/Helper';
import useIsMobileHooks from 'hooks/useIsMobileHooks';
// import useAccessPermissionHook from 'hooks/useAccessPermissionHook';
import { PRIVILEGE_ID } from 'utils/AccessPermissionConfig';
import SkeletonPage from 'components/Common/SkeletonPage';
import { ButtonAdvanceFilter } from 'components/Common/ButtonAdvanceFilter';
import Error403 from 'components/Error/Error403';
import BaseAdvanceFilter from 'components/CustomDrawer/BaseAdvanceFilter';
import CellTable from 'components/Common/CellTable';
import { useNavigate } from 'react-router-dom';
import { APP_ROUTE_PREFIX, RouteConstant } from 'routes/routesConstant';
import useOrgRepo from "../../../services/repo/useOrgRepo";
import useDeptRepo from "../../../services/repo/useDepartmentRepo";
import useDivRepo from "../../../services/repo/useDivisionRepo";

export default function Department() {

    useTopbarTitleHooks("Department");
    const { isLoading: isLoadingList, getDepartmentList } = useDeptRepo(false)
    const { isLoading: isLoadingOrgList, getOrgList } = useOrgRepo(false)
    const { isLoading: isLoadingDelete, deleteDepartment } = useDeptRepo(false);
    const { isLoading: isLoadingDivList, getDivisionList } = useDivRepo(false)

    const isMobile = useIsMobileHooks()
    const [form] = Form.useForm()
    const navigate = useNavigate();
    const [data, setData] = useState()
    const [totalData, setTotalData] = useState(0)
    const [isOpenAdvanceFilter, setIsOpenAdvanceFilter] = useState(false)


    const isLoadingPrivilege = useRef(true)
    const hasPrivilegePage = useRef(true)
    const [isLoadedPrivilege, setIsLoadedPrivilege] = useState(false)
    const [showButtonAdd, setShowButtonAdd] = useState(false)

    const [filters, setFilters] = useState({
        deptCode: "",
        deptName: "",
        orgId: null,
        status: ""
    })

    const [tableParams, setTableParams] = useState({
        pageNumber: 1,
        pageSize: 10,
        filter: { ...filters },
        orderBy: "deptName",
        isAscending: true
    });

    const onSearch = (value) => {

        const formValues = form.getFieldsValue();
        const selectedOrg = formValues.orgId;
        const orgId = selectedOrg?.value ?? selectedOrg ?? null;
        setTableParams(prev => ({
            ...prev,
            pageNumber: 1,
            filter: {
                ...filters,
                orgId: orgId
            }
        }))
    };

    const onSearchClick = () => {
        onSearch()
        setIsOpenAdvanceFilter(false)
    }

    const fetchData = async () => {

        const payload = {
            ...tableParams
        }

        const res = await getDepartmentList(payload)
        if (res?.detail == 'OK' && res?.status === 200) {
            setData(res?.data?.content)
            setTotalData(res?.data?.totalElements)
        }
    };

    const handleTableChange = (pagination, filters, sorter) => {
        setTableParams(prevParams => ({
            ...prevParams,
            pageNumber: pagination?.current,
            pageSize: pagination?.pageSize,
            orderBy: sorter?.field || prevParams?.orderBy,
            isAscending: sorterTable(sorter?.order, prevParams?.isAscending)
        }));
        if (pagination.pageSize !== tableParams?.pageSize) {
            setData([]);
        }
    };

    const handleAdd = () => {
        navigate(APP_ROUTE_PREFIX + "/" + RouteConstant.organization.department.create);
    }

    const handleEdit = async (data) => {
        const key = 'loadingEdit';
        loadingToastId(Constant.message.loading, key)
        navigate(APP_ROUTE_PREFIX + "/" + RouteConstant.organization.department.edit(data?.deptId));
        dismissToast(key)
    }

    const handleDelete = async (record) => {
        const key = 'deletePosition';
        try {

            debugger

            loadingToastId(Constant.message.loading, key)

            const response = await deleteDepartment({ deptId: record.deptId });

            if (response?.status === 200 && response?.detail === 'OK') {
                successToast(Constant.message.deleteDataSuccess);
                fetchData(); // refresh table
            } else {
                errorToast(Constant.message.deleteDataFail);
            }
        } catch (error) {
            console.error('Error:', error);
            errorToast(Constant.message.deleteDataFail);
        } finally {
            dismissToast(key); //tambahkan ini agar loading hilang
        }
    };

    const fetchCheckPrivilege = async () => {
        setShowButtonAdd('Add')
        isLoadingPrivilege.current = false
        hasPrivilegePage.current = true;
        setIsLoadedPrivilege(true)
        fetchData();
        dismissToast(PRIVILEGE_ID.AddEditDivision);
    }

    // Org dropdown
    const [orgOptions, setOrgOptions] = useState([])
    const fetchDataOrg = async () => {
        const payload = {
            pageNumber: 1,
            pageSize: 0,
            orderBy: "orgId",
            isAscending: true,
            filter: {
                orgId: null,
                orgName: "",
                status: "true",
            },
        }

        const res = await getOrgList(payload)
        if (res?.detail == 'OK' && res?.status === 200) {

            const options = res.data.content.map(item => ({
                label: item?.orgName,
                value: item?.orgId,
            }));

            setOrgOptions(options);

            if (options.length === 1) {
                const onlyOption = options[0];

                form.setFieldsValue({ orgId: onlyOption }); // isinya harus { label, value }
                setFilters((prev) => ({ ...prev, orgId: onlyOption.value }));

                setTableParams((prev) => ({
                    ...prev,
                    filter: {
                        ...prev.filter,
                        orgId: onlyOption.value
                    }
                }));



                // ✅ Trigger load Division list berdasarkan org tersebut
                fetchDataDivision(onlyOption.value);
            }
            // setOrgOptions(() => {
            //     return res?.data?.content.map(item => {
            //         return { label: item?.orgName, value: item?.orgId }
            //     })
            // })
        }
    }

    const [divOptions, setDivOptions] = useState([])
    const fetchDataDivision = async (orgId) => {
        console.log("🚀 Calling fetchDataDivision with orgId:", orgId); // ⬅ ini wajib muncul

        const payload = {
            pageNumber: 1,
            pageSize: 0,
            filter: {
                divCode: "",
                divName: "",
                orgId: orgId,
                divId: null,
                status: "true",
            },
            orderBy: "divCode",
            isAscending: true
        }
        setDivOptions([])

        const res = await getDivisionList(payload)

        console.log("👉 Payload Division:", payload);
        console.log("📥 Response Division:", res?.data?.content);


        if (res?.detail == 'OK' && res?.status === 200) {
            setDivOptions(() => {
                return res?.data?.content.map(item => {
                    return {
                        value: item?.divId,
                        label: item?.divName
                    }
                })
            })
        }
    }


    useEffect(() => {
        fetchCheckPrivilege()
    }, [])

    useEffect(() => {
        if (isLoadedPrivilege) {
            fetchData();
        }
        fetchDataOrg();
    }, [JSON.stringify(tableParams)]);

    useEffect(() => {
        const timeOutId = setTimeout(() => {
            if (isLoadedPrivilege && !isMobile) {
                onSearch()
            }
        }, Constant.delayFilter);
        return () => clearTimeout(timeOutId);
    }, [filters]);

    const filterUI = () => {
        return (
            <Form layout="horizontal" form={form}>
                <Row gutter={16}>
                    <Col xs={24} sm={10} md={7}>
                        <Form.Item name="orgId" label="Filter">
                            <Select
                                style={{ width: '100%' }}
                                allowClear
                                showSearch
                                placeholder="Select Organization"
                                loading={isLoadingOrgList}
                                options={orgOptions}
                                onChange={(value, option) => {
                                    const orgValue = value?.value ?? value ?? null;
                                    console.log("👉 Selected Org Value:", orgValue); // ⬅ Tambahkan ini
                                    console.log("👉 Option Object:", option);         // ⬅ Tambahkan ini
                                    setFilters((prev) => ({
                                        ...prev,
                                        // orgId: value || null, // pastikan null kalau kosong
                                        orgId: orgValue, // pastikan null kalau kosong
                                        divId: null,           // reset divId saat ganti org
                                    }));
                                    form.setFieldsValue({ divFilter: undefined }); // reset divFilter di Form

                                    if (orgValue) {
                                        fetchDataDivision(orgValue);
                                    } else {
                                        setDivOptions([]); // kalau org kosong, kosongkan divisi
                                    }
                                }}
                                filterOption={(input, option) =>
                                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                            />
                        </Form.Item>
                    </Col>

                    <Col xs={24} sm={10} md={5}>
                        <Form.Item name="divFilter">
                            <Select
                                style={{ width: '100%' }}
                                allowClear
                                showSearch
                                placeholder="Select Division"
                                loading={isLoadingDivList}
                                disabled={!filters?.orgId} // optional UX: disable kalau belum pilih org
                                options={divOptions}
                                onChange={(value) => {
                                    setFilters((prev) => ({
                                        ...prev,
                                        divId: value || null, // pastikan null kalau kosong
                                    }));
                                }}

                            />
                        </Form.Item>
                    </Col>
                    <Col xs={16} sm={10} md={4}>
                        <Form.Item name='deptCodeFilter'>
                            <Input
                                allowClear
                                placeholder={Constant.placeholder.enterCode}
                                onChange={(e) => {
                                    setFilters(prev => ({
                                        ...prev,
                                        deptCode: e.target.value
                                    }))
                                }}
                            />
                        </Form.Item>
                    </Col>
                    <Col xs={16} sm={10} md={4}>
                        <Form.Item name='deptNameFilterFilter'>
                            <Input
                                allowClear
                                placeholder={Constant.placeholder.enterName}
                                onChange={e => {
                                    setFilters(prev => ({
                                        ...prev,
                                        deptName: e.target.value
                                    }))
                                }}
                            />
                        </Form.Item>
                    </Col>

                    <Col xs={24} sm={10} md={4}>
                        <Form.Item name='statusFilter'>
                            <Select
                                allowClear
                                placeholder="Select Status"
                                onChange={(value) => {
                                    setFilters(prev => ({
                                        ...prev,
                                        status: value
                                    }));
                                }}
                            >
                                <Select.Option value="true">Active</Select.Option>
                                <Select.Option value="false">Inactive</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>


                </Row>
            </Form>
        )
    }

    const columns = [
        {
            title: 'Action',
            key: 'action',
            width: "50px",
            render: (_, record) => {
                const buttons = showButtonAdd ? ['edit', 'delete'] : ['delete']
                return (
                    <ButtonAction
                        buttons={buttons}
                        onEdit={handleEdit}
                        onDelete={handleDelete}
                        // onView={handleRowClick}
                        data={record}
                        loadingDelete={isLoadingDelete}
                    />
                )
            }
        },
        {
            title: 'Organization',
            dataIndex: 'orgName',
            sorter: true,
            width: "200px",
            sorter: true,
            render: (data) => <CellTable data={data} />
        },
        {
            title: 'Division',
            dataIndex: 'divName',
            sorter: true,
            width: "200px",
            sorter: true,
            render: (data) => <CellTable data={data} />
        },
        {
            title: 'Code',
            dataIndex: 'deptCode',
            sorter: true,
            width: "170px",
            render: (data) => <CellTable data={data} />
        },
        {
            title: 'Name',
            sorter: true,
            dataIndex: 'deptName',
            width: "200px",
            render: (data) => <CellTable data={data} />
        },
        {
            title: 'Status',
            dataIndex: 'status',
            width: "100px",
            render: (data) => <CellTable data={String(data).toLowerCase() === "true" ? "Active" : "Inactive"} />
            // render: (data) => <CellTable data={data} />
        }
    ];
    return (
        <>
            {hasPrivilegePage.current ?
                <Space direction="vertical" size="large" className='space-vertical-flex'>
                    <Card size="big" bordered={false}>
                        {isLoadingPrivilege.current ? <SkeletonPage /> :
                            <>
                                <Row gutter={[16, 16]}>
                                    <Col xs={24} sm={20} xl={18}>
                                        {showButtonAdd && <ButtonAdd onClick={handleAdd} />}
                                    </Col>
                                </Row>
                                <Divider dashed className='mb-1 mt-1' />

                                {isMobile ?
                                    <ButtonAdvanceFilter onClick={() => setIsOpenAdvanceFilter(true)} />
                                    : filterUI()
                                }

                                <CustomAntdTable
                                    columns={columns}
                                    dataSource={data}
                                    rowKey={"deptId"}
                                    tableParam={tableParams}
                                    totalData={totalData}
                                    loading={isLoadingList}
                                    onChange={handleTableChange}
                                // rowClick={handleRowClick}
                                // isOpenDrawer={isOpenDrawer}
                                // idDataHighlight={idHighlightRow}
                                />
                            </>
                        }
                    </Card>
                </Space> : (<Error403 />)
            }



            {isOpenAdvanceFilter &&
                <BaseAdvanceFilter
                    onClose={() => setIsOpenAdvanceFilter(false)}
                    onSearchClick={onSearchClick}>
                    {filterUI()}
                </BaseAdvanceFilter>}
        </>
    )
}
